const ACTIVATE_SERVICE_API_URL = '/h20/api/config/v2.0/activate/v1';

export class ActivateServiceConfig {
  getWarehousesURL() {
    return `${ACTIVATE_SERVICE_API_URL}/warehouses`;
  }

  getAppsURL() {
    return `${ACTIVATE_SERVICE_API_URL}/apps`;
  }

  getModelsURL() {
    return `${ACTIVATE_SERVICE_API_URL}/models`;
  }

  getPipelinesURL() {
    return `${ACTIVATE_SERVICE_API_URL}/pipelines`;
  }

  getPipelineRunsURL() {
    return `${ACTIVATE_SERVICE_API_URL}/pipeline-runs`;
  }

  getActionStateURL() {
    return `${ACTIVATE_SERVICE_API_URL}/action-state`;
  }
}

export const activateServiceConfig = new ActivateServiceConfig();
